module.exports = __webpack_public_path__ + "static/img/temp_bg.339bfbd6.jpeg";